<template>
  <div id="SysOperationDescription">
    <el-dialog :center="true" title="请求参数与返回值明细" :visible.sync="dialogVisible" width="900px">
      <div class="modal-body">
        <h4>请求参数：</h4>
        <div id="requestParamDetail" class="requestInfo">
          {{content}}
        </div>
        <h4>返回值：</h4>
        <div id="returnDataDetail" class="requestInfo">
          {{returnData}}
        </div>
      </div>
      <div class="eb-button-group">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
export default {
  name: 'SysOperationDescription',
  data() {
    return {
      dialogVisible: false,
      content: '',
      returnData: ''
    };
  },
  created() {
    eventBus.$on('showSysOperationDescription', row => {
      this.dialogVisible = true;
      this.content = row.content;
      this.returnData = row.returnData;
    });
  },
  beforeDestroy() {
    eventBus.$off('showSysOperationDescription');
  }
};
</script>
<style lang="less" scoped>
#SysOperationDescription {
  .modal-body {
    position: relative;
  }
  #requestParamDetail {
    height: 80px;
    min-height: 80px;
  }
  #returnDataDetail {
    height: 200px;
    min-height: 200px;
  }
  .requestInfo {
    margin-top: 5px;
    width: 100%;
    overflow: auto;
    color: #feefa9;
    font-family: Courier New, Courier, monospace;
    background-color: #1b763f;
    font-weight: bold;
  }
}
</style>
